export default __webpack_public_path__ + "static/media/16.f356d8dd.svg";